/**
 * To check whether running on public or private url
 * @returns backend base url
 */
const isPublicUrl = () => {
    return (window.location.origin.includes("aks") || window.location.origin.includes("localhost")) ? false : true;
}

export const ApiPath = {
    baseUrl: isPublicUrl() ? process.env.REACT_APP_BASE_PUBLIC_URL : process.env.REACT_APP_BASE_URL // Albertson's Backend IP Address
}
export const ApiPathRESE = {
    baseUrl: isPublicUrl() ? process.env.REACT_APP_BASE_PUBLIC_RESE_URL : process.env.REACT_APP_BASE_RESE_URL // Albertson's Backend IP Address
}
export const ApiPathDataCategorization = {
    baseUrl: process.env.REACT_APP_DATA_CAT_BASE_URL || 'http://localhost:8080/api/v1' // Data Categorization Backend IP Address
}